import React, { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { marked } from 'marked';
import DOMPurify from 'dompurify';
import classNames from 'classnames';
import PropTypes from "prop-types";

const PURIFY_CONFIG = { ADD_ATTR: ['target'] };
Markdown.propTypes = {
  text: PropTypes.string,
  white: PropTypes.bool,
};
export default function Markdown(props) {
  const { text, white = false } = props;
  const navigate = useNavigate();

  const html = useMemo(() => {
    if (!text) return '';
    return DOMPurify.sanitize(marked.parse(text), PURIFY_CONFIG);
  }, [text]);

  const handleClick = useCallback((event) => {
    const anchor = event.target.closest('a');
    if (!anchor || event.defaultPrevented) return;

    // Let the browser handle new-tab, downloads, modified clicks, external targets
    if (event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (anchor.target && anchor.target !== '_self') return;
    if (anchor.hasAttribute('download')) return;

    const url = new URL(anchor.href, window.location.origin);

    // Only intercept plain http(s) same-origin links; let mailto:, tel:,
    // javascript:, etc. fall through to normal browser handling
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return;
    if (url.origin !== window.location.origin) return;

    event.preventDefault();
    navigate(`${url.pathname}${url.search}${url.hash}`);
  }, [navigate]);

  if (!text) {
    return null;
  }

  return (
    <span
      className={classNames(
        'prose',
        white && 'prose-a:text-white prose-p:text-white',
        'prose-p:leading-6',
        'prose-p:mb-4',
        'last-of-type:prose-p:mb-0',
        'text-base'
      )}
      onClick={handleClick}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
